import React, { useEffect, useState } from 'react'
import styled, { keyframes } from 'styled-components'
import { useConfigContext } from '../../App/App'

const Wrapper = styled.div`
  background: ${(props) => props.theme.colorProgressBg};
  height: .7rem;
  width: 100%;
  position: absolute;
  left: 0;
  top: 0;

  &:empty {
    background: transparent;
  }
`

const progress = keyframes`
  from {
    width: 0;
  }

  to {
    width: 100%;
  }
`

interface IBarProps {
  rotationInterval: number
}

const Bar = styled.div<IBarProps>`
  background: ${(props) => props.theme.colorProgressBar};
  height: 100%;
  animation: ${progress} ${(props) => props.rotationInterval}s linear;
`

interface IProps {
  routerOffset: number
  currentOffset: number
  nextOffset: number
  onProgressEnd: () => void
}

const ProgressBar = ({ routerOffset, currentOffset, nextOffset, onProgressEnd }: IProps) => {
  const [visible, toggleVisible] = useState(true)
  const { rotationInterval } = useConfigContext()

  const onAnimationEnd = () => {
    toggleVisible(false)
    onProgressEnd()
  }

  useEffect(() => {
    toggleVisible(true)
  }, [routerOffset, currentOffset, nextOffset])

  return (
    <Wrapper>
      {visible && <Bar rotationInterval={rotationInterval} onAnimationEnd={onAnimationEnd}/>}
    </Wrapper>
  )
}

export default ProgressBar
